import axios from "axios";

export default axios.create({
    baseURL: 'https://netreach.app:4242'
    // baseURL: 'http://localhost:4242'
});